import React from 'react'

export default function BackArrow(props) {
  return (
    <>
      <div  style={{marginLeft:'20px', marginTop:'15px', color:'black',fontSize:'35px'}}  onClick={props.onClick}>&#8592;</div>
      
    </>
  )
}
